module.exports = __webpack_public_path__ + "media/images/dummy-content/user-1-header-7939fb05e2cf465c6bc9db7c6a7a7832.jpg";